export const REF_DELIMITER = '_r_'

export const getUniqueId = (refId: string, originalId: string) => `${refId}${REF_DELIMITER}${originalId}`

export const getRefCompIdFromInflatedId = (id: string): string => id.split(`${REF_DELIMITER}`)[0]
